export default __webpack_public_path__ + "assets/images/813748444b4a092e596ed58f497a7ddb.png";